import { render } from "./CmpRespuestasRapidasWhatsapp.vue?vue&type=template&id=657d00e0&scoped=true"
import script from "./CmpRespuestasRapidasWhatsapp.vue?vue&type=script&lang=js"
export * from "./CmpRespuestasRapidasWhatsapp.vue?vue&type=script&lang=js"

import "./CmpRespuestasRapidasWhatsapp.vue?vue&type=style&index=0&id=657d00e0&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657d00e0"]])

export default __exports__